var map = {
	"./mountain-badge--dark.svg": 913,
	"./mountain-badge--light.svg": 914,
	"./surf-badge--dark.svg": 915,
	"./surf-badge--light.svg": 916,
	"./tide-badge--dark.svg": 917,
	"./tide-badge--light.svg": 918,
	"./weather-badge--dark.svg": 919,
	"./weather-badge--light.svg": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912;